import { Box, Button, Container, Typography } from "@mui/material";
import React, { useContext } from "react";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";

const BannerContent = ({ data }) => {
  const { language } = useContext(LanguageContext);

  const onClick = (event) => {
    window.open(`${data.buttonLink}`);
    event.stopPropagation();
  };

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        height: { xs: "350px", md: "420px" },
        "&:hover .banner-bg": {
          transform: data.available === "True" ? "scale(1.04)" : "none",
        },
        "&:hover .banner-overlay": {
          background:
            "linear-gradient(to right, rgba(33,3,6,0.85) 0%, rgba(33,3,6,0.55) 50%, rgba(33,3,6,0.25) 100%)",
        },
      }}
    >
      {/* Background image */}
      <Box
        className="banner-bg"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${require(`assets/images/${data.image}`)})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          transition: "transform 0.8s ease",
        }}
      />

      {/* Gradient overlay */}
      <Box
        className="banner-overlay"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(to right, rgba(33,3,6,0.8) 0%, rgba(33,3,6,0.5) 50%, rgba(33,3,6,0.2) 100%)",
          transition: "background 0.5s ease",
        }}
      />

      {/* Content - bottom aligned */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container
          maxWidth="md"
          sx={{
            py: { xs: 4, md: 5 },
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography
            color="secondary"
            sx={{
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 400,
              fontSize: { xs: "1.6rem", md: "2rem" },
              letterSpacing: "0.06em",
              mb: 1,
              textShadow: "0 2px 8px rgba(0,0,0,0.3)",
            }}
          >
            {data.name}
            {data.alNumber && (
              <Box
                component="span"
                sx={{
                  ml: 1.2,
                  fontFamily: "'Lato', sans-serif",
                  fontSize: { xs: "0.7rem", md: "0.75rem" },
                  letterSpacing: "0.08em",
                  opacity: 0.55,
                  fontWeight: 300,
                  verticalAlign: "middle",
                }}
              >
                Nº {data.alNumber}
              </Box>
            )}
          </Typography>
          <Box
            sx={{
              width: 45,
              height: "1px",
              background: "var(--clr-primary-light)",
              mb: 1.5,
              mx: { xs: "auto", md: 0 },
            }}
          />
          <Typography
            variant="body1"
            color="secondary"
            sx={{
              fontSize: { xs: "0.85rem", md: "0.9rem" },
              lineHeight: 1.8,
              opacity: 0.9,
              mb: 2.5,
              maxWidth: 600,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              whiteSpace: "pre-wrap",
              mx: { xs: "auto", md: 0 },
            }}
          >
            {data.description}
          </Typography>
          {data.available === "True" ? (
            <Button
              variant="contained"
              color="primary"
              onClick={onClick}
              target="_blank"
              sx={{
                borderRadius: 0,
                px: 3.5,
                py: 0.9,
                fontFamily: "'Lato', sans-serif",
                fontWeight: 400,
                letterSpacing: "0.1em",
                fontSize: "0.78rem",
                backgroundColor: "transparent",
                border: "1px solid var(--clr-primary-light)",
                color: "var(--clr-primary-light)",
                "&:hover": {
                  backgroundColor: "var(--clr-primary)",
                  borderColor: "var(--clr-primary)",
                  color: "#fff",
                },
                transition: "all 0.4s ease",
              }}
            >
              {language === "pt" ? "Reserve Online" : "Book Online"}
            </Button>
          ) : (
            <Button
              disabled
              sx={{
                borderRadius: 0,
                px: 3.5,
                py: 0.9,
                fontFamily: "'Lato', sans-serif",
                fontWeight: 400,
                letterSpacing: "0.1em",
                fontSize: "0.78rem",
                border: "1px solid rgba(255,255,255,0.3)",
                color: "rgba(255,255,255,0.4) !important",
              }}
            >
              {language === "pt" ? "Indisponível" : "Unavailable"}
            </Button>
          )}
        </Container>
      </Box>
    </Box>
  );
};

export default BannerContent;
